const modules = new Map([
  ['layered-slideshow-component', () => import('@theme/layered-slideshow')],
  ['media-gallery', () => import('@theme/media-gallery')],
  ['zoom-dialog', () => import('@theme/zoom-dialog')],
  ['drag-zoom-wrapper', () => import('@theme/drag-zoom-wrapper')],
  ['volume-pricing', () => import('@theme/volume-pricing')],
  ['price-per-item', () => import('@theme/price-per-item')],
  ['volume-pricing-info', () => import('@theme/volume-pricing-info')],
  ['video-background-component', () => import('@theme/video-background')],
  ['rte-formatter', () => import('@theme/rte-formatter')],
  ['instagram-marquee', () => import('@theme/instagram-marquee')],
]);

function loadComponents(root) {
  for (const [selector, load] of modules) {
    if (!root.matches?.(selector) && !root.querySelector(selector)) continue;
    modules.delete(selector);
    load().catch((error) => console.error(`Unable to load ${selector}`, error));
  }
  if (!modules.size) observer.disconnect();
}

const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) loadComponents(node);
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
loadComponents(document);
